import NavBar from "../components/NavBar";
import "../App.css";

const CORE_VALUES = [
  {
    number: "01",
    title: "기록의 여백",
    subtitle: "Space for Thought",
    description:
      "책은 저자의 생각으로 가득 차 있지만, 그 사이사이의 흰 공간은 오롯이 독자의 몫입니다. '여백'은 독자가 책을 읽으며 떠오른 파편적인 생각들을 머뭇거림 없이 적어 내려갈 수 있는 심리적 여백을 제공합니다.",
  },
  {
    number: "02",
    title: "사유의 채움",
    subtitle: "Filling the Void",
    description:
      "책에 남긴 한 줄의 메모는 시간이 흐르면 나를 구성하는 단단한 내면의 양분이 됩니다. 텍스트를 수집하는 것에 그치지 않고, 그 기록들이 모여 사용자의 공허함을 지적인 충만함으로 바꾸는 과정에 집중합니다.",
  },
  {
    number: "03",
    title: "불완전의 미학",
    subtitle: "Beauty of Incompletion",
    description:
      "완벽한 서평을 써야 한다는 부담을 버립니다. 여백은 원래 비어 있는 것이 자연스럽듯, 정제되지 않은 낙서나 짧은 감상만으로도 충분히 가치 있는 기록이 된다는 여유로운 기록 문화를 지향합니다.",
  },
];

function BrandPage() {
  return (
    <div className="app">
      <NavBar />

      <main className="brand-page">
        <section className="brand-hero">
          <p className="brand-eyebrow">Brand Philosophy</p>
          <h1 className="brand-title">여백을 남기다,<br></br>나를 채우다.</h1>
          <p className="brand-subtitle">책의 끝에서 시작되는 나만의 이야기</p>
          <div className="brand-hero-note">
            <p>
              세상은 온통 빽빽한 정보들로 가득합니다. 우리는 남들의 목소리를
              읽어내느라 정작 내 마음의 빈칸을 들여다볼 시간을 잃어버렸을지도
              모릅니다.
            </p>
            <p>
              <strong>여백</strong>은 책의 귀퉁이에 끄적였던 당신의 사소한
              문장들에 주목합니다. 저자의 문장과 당신의 생각이 만나는 그 좁은
              틈새야말로, 당신이 가장 진실해지는 공간이기 때문입니다.
            </p>
            <p>책의 여백에 당신의 흔적을 남겨보세요. 비워진 만큼 깊어지고,
            기록한 만큼 채워지는 놀라운 경험이 시작됩니다.
          </p>
          </div>
        </section>

        <section className="brand-section">
          <div className="brand-section-heading">
            <p className="brand-section-kicker">Core Values</p>
            <h2>비워진 만큼 깊어지고,<br></br>기록한 만큼 채워지는 경험</h2>
          </div>
          <div className="brand-values">
            {CORE_VALUES.map((value) => (
              <article key={value.number} className="brand-value-card">
                <p className="brand-value-number">{value.number}</p>
                <h3>{value.title}</h3>
                <p className="brand-value-subtitle">{value.subtitle}</p>
                <p className="brand-value-description">{value.description}</p>
              </article>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

export default BrandPage;
